import React from 'react';
import { TextField, MenuItem, ListSubheader } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

import { climateAttrs } from '../../store/constants/climateAttrs';
import { hazardAttrs } from '../../store/constants/hazardAttrs';

import {
  selectTheme,
  selectAttributeId,
} from '../../store/options/options.selector';
import {
  changeClimateOption,
  changeHazardOption,
} from '../../store/options/options.slice';
import {
  getDataAsync,
  getProjectionDataAsync,
} from '../../store/data/data.slice';
import { getEpisodesDataAsync } from '../../store/episodes/episodes.slice';
import { changeEventDisplayVisible } from '../../store/ui/ui.slice';

import './attribute-selector.styles.scss';

export default function AttributeSelector() {
  const theme = useSelector(selectTheme);
  const attributeId = useSelector(selectAttributeId);
  const dispatch = useDispatch();

  const handleChange = async (e) => {
    const newValue = e.target.value;
    
    if (newValue <= 1999) {
      dispatch(changeEventDisplayVisible(false));
      await dispatch(changeClimateOption(newValue));
      await dispatch(getDataAsync());
      dispatch(getProjectionDataAsync({ type: 'changeAttribute', payload: newValue }));
    } else if (newValue <= 2999) {
      dispatch(changeEventDisplayVisible(false));
      await dispatch(changeHazardOption(newValue));
      await dispatch(getDataAsync());
      dispatch(getEpisodesDataAsync({ type: 'changeAttribute', payload: newValue }));
    } else if (newValue <= 3999) {
      const url = climateAttrs.find(attr => attr.id === newValue).url;
      window.open(url, "_blank", "noreferrer");
    } else if (newValue <= 4999) {
      const url = hazardAttrs.find(attr => attr.id === newValue).url;
      window.open(url, "_blank", "noreferrer");
    }
  };

  const renderOptions = (themeIdx, attrsArr, headingText) => {
    const filteredAttrs = attrsArr
      .filter((attr) => attr.themes.includes(themeIdx))
      .sort((a, b) => (a.name > b.name ? 1 : -1));

    return filteredAttrs.reduce((acc, { id, name }, i) => {
      if (!i)
        acc.push(
          <ListSubheader key={'subheader' + id}>{headingText}</ListSubheader>
        );
      acc.push(
        <MenuItem key={id} value={id}>
          {name}
        </MenuItem>
      );
      return acc;
    }, []);
  };

  return (
    <div>
      <TextField
        select
        label='Hazards'
        variant='standard'
        value={attributeId}
        onChange={handleChange}
      >
        {renderOptions(theme, climateAttrs, 'Climate Metrics and Projections')}
        {renderOptions(theme, hazardAttrs, 'Hazard Types')}
      </TextField>
    </div>
  );
}
